import styled from 'styled-components';
import { VISUALIZATION_CONTENT_CONTAINER_CLASS_NAME } from '@ardoq/global-consts';
import { classes } from '@ardoq/common-helpers';

export const CapabilityMapContentContainer = styled.div.attrs(props => ({
  className: classes(
    VISUALIZATION_CONTENT_CONTAINER_CLASS_NAME,
    props.className
  ),
}))`
  display: flex;
  flex-direction: row;
  padding: 5px;
`;
